import { Component } from '@angular/core';
@Component({
  selector: 'app-outbount-link-icon',
  templateUrl: './outbount-link-icon.component.html',
  styleUrls: ['./outbount-link-icon.component.scss']
})
export class OutbountLinkIconComponent {
  constructor() { }
}
